module.exports = __webpack_public_path__ + "static/media/bn.87d48610.JPG";